import {CnaeImpedidoPesquisaComponent} from './../pesquisa/cnae-impedido-pesquisa.component';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EntityPagedRequestParameters, MessageChannelService, messageLevel} from '@bndes/bndes-ux4/bndes-angular-utils';
import {BnModalMessageService} from '@bndes/bndes-ux4/bn-modal-message';
import {MascaraCnaeImpedido} from 'src/app/model/mascara-cnae-impedido.model';
import {LabelTipoOperacao} from 'src/app/model/modalidade_garantia.model';
import {CnaeImpedidoService} from '../cnae-impedido.service';
import {ObjetivosFinanciamentoMap} from 'src/app/model/objetivo-financiamento.model';

@Component({
    selector: 'app-cnae-impedido-listagem',
    templateUrl: './cnae-impedido-listagem.component.html',
    styleUrls: ['./cnae-impedido-listagem.component.scss'],
    standalone: false
})
export class CnaeImpedidoListagemComponent {

  constructor(private cnaeService: CnaeImpedidoService,
              private messageService: MessageChannelService,
              private modalService: BnModalMessageService,
              private CnaeImpedidoPesquisaComponent: CnaeImpedidoPesquisaComponent) {

  }

  @Input() public cnaeImpedido: MascaraCnaeImpedido[] = [];
  @Input() public filtroCnaeImpedido: boolean = false;
  @Input() public permissaoEdicao:  boolean = false;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  public opcoesPaginacao: number[] = [10, 15, 20];
  public listaCnae: any[];
  public countCnae: number;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarCnaes: EventEmitter<any> = new EventEmitter<any>();


  public cnaeImpedidoFiltrada: MascaraCnaeImpedido[] = [];
  public labelsOperacao = LabelTipoOperacao;
  public labelsObjetivoFinanciamento = ObjetivosFinanciamentoMap;

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  public labelOperacao(item) {
    return this.labelsOperacao.get(item);
  }

  public labelObjetivoFinanciamento(item) {
    return this.labelsObjetivoFinanciamento.get(item);
  }

  public encerrarVigenciaCnaeImpedido(ideMascaraCnaeImpedido: number) {
    this.abreModalConfirmacao().then((resp) => {
      if(resp == true) {
        this.cnaeService.encerrarVigenciaCnaeImpedido(ideMascaraCnaeImpedido).subscribe(() => {
          this.messageService.addMessage({
            title: 'Sucesso',
            type: 'CRUD_OPERATION',
            level: messageLevel.SUCCESS,
            message: 'Máscara de CNAE encerrada com sucesso. A CNAE não estará mais ativa a partir do próximo dia.'
          })
          this.CnaeImpedidoPesquisaComponent.buscarTodos(false);
        })
      }
    })
  }

  async abreModalConfirmacao(): Promise<boolean> {
    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm('Confirmação', 'Confirma encerrar a vigência?').result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  btnExportarCnaes() {
    this.exportarCnaes.emit(null);
  }

}
